import { Link } from "react-router-dom";
import { Phone, MessageCircle, FileText } from "lucide-react";
import { waLink, PHONE_HREF } from "@/lib/contact";

export default function MobileActionBar() {
  return (
    <div
      data-testid="mobile-action-bar"
      className="fixed bottom-0 left-0 right-0 z-40 md:hidden bg-forest-900/95 backdrop-blur-md border-t border-bone-100/15 flex safe-area-inset-bottom"
    >
      <a
        href={PHONE_HREF}
        data-testid="mobile-cta-call"
        className="flex-1 flex flex-col items-center gap-1 py-3 text-bone-100 active:bg-bone-100/10 border-r border-bone-100/10"
      >
        <Phone size={18} className="text-terracotta-500" />
        <span className="text-[10px] uppercase tracking-widest font-medium">Call</span>
      </a>
      <a
        href={waLink()}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="mobile-cta-whatsapp"
        className="flex-1 flex flex-col items-center gap-1 py-3 text-bone-100 active:bg-bone-100/10 border-r border-bone-100/10"
      >
        <MessageCircle size={18} className="fill-[#25D366] text-[#25D366]" strokeWidth={0} />
        <span className="text-[10px] uppercase tracking-widest font-medium">WhatsApp</span>
      </a>
      <Link
        to="/quote"
        data-testid="mobile-cta-quote"
        className="flex-1 flex flex-col items-center gap-1 py-3 bg-terracotta-500 text-forest-900 font-medium active:bg-terracotta-400"
      >
        <FileText size={18} />
        <span className="text-[10px] uppercase tracking-widest">Get quote</span>
      </Link>
    </div>
  );
}
